import React, { Component } from 'react';
import { Field } from 'formik';
import GuestOrderInput from '../../../../components/common/Formik/GuestOrderInput';
import {trans} from "../../../../utils/helpers";

class CheckAvailabilityStep extends Component {

	render() {
		const {
			values,
			errors,
			touched,
			handleBlur,
			handleChange,
			availablePlansError,
			availablePlansLoader
		} = this.props;

		return (
			<div className="form-section fx-fadein" id="fs1">

				<h4 className="cp-form-title">{trans('en-us', 'guestOrderScreen.checkAvailability.title')}</h4>

				<div className="form-row">

					<GuestOrderInput
						type="text"
						label="Your street address"
						name="street"
						size="col-12"
						errors={errors}
						value={values.street}
						touched={touched}
						onChange={handleChange}
						onBlur={handleBlur}
						isDisabled={availablePlansLoader}
					/>

					<GuestOrderInput
						type="text"
						name="unit"
						label="Unit #"
						size="col-6"
						errors={errors}
						value={values.unit}
						touched={touched}
						onChange={handleChange}
						onBlur={handleBlur}
						isDisabled={availablePlansLoader}
					/>

					<GuestOrderInput
						type="text"
						name="zipcode"
						label="Zip"
						size="col-6"
						errors={errors}
						value={values.zipcode}
						touched={touched}
						onChange={handleChange}
						onBlur={handleBlur}
						isDisabled={availablePlansLoader}
					/>

					{availablePlansError && <p style={{ color: 'red' }}>{availablePlansError}</p>}

					<div className="form-group form-group-button col-12">
						<button
							type="submit"
							className="btn btn-primary btn-block"
							data-target="fs2"
							disabled={availablePlansLoader}
						>
							Check Availability {availablePlansLoader && <i className="fas fa-fw fa-spin fa-spinner" />}
						</button>
					</div>

				</div>

			</div>
		);
	}
}

export default CheckAvailabilityStep;
